import {
  Button,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@baseball-near-you/ui';
import { PATHS } from '@bb/lib/constants';
import { urlFor } from '@bb/lib/sanity/utils';
import type { BlogCarousel as IBlogCarousel, Post } from '@bb/sanity.types';
import Link from 'next/link';
import { BlogPostLink } from '../../Blog/BlogPostLink';
import { SanityWrapper, Title } from '../SanityWrapper';

export function BlogCarousel({ block }: { block: IBlogCarousel }) {
  return (
    <SanityWrapper>
      <div className="mb-2 flex w-full justify-between">
        {!!block.title && <Title title={block.title} />}
        <Link href={PATHS.Blog}>
          <Button className="title bg-red">VIEW ALL</Button>
        </Link>
      </div>
      <Carousel opts={{ align: 'start' }} className="w-full">
        <CarouselPrevious />
        <CarouselNext />
        <CarouselContent className="-ml-4">
          {(block.blogs as any as Post[])?.map((blog) => (
            <CarouselItem key={blog._id} className="md:basis-1/2 lg:basis-1/3">
              <BlogPostLink
                id={blog._id}
                title={blog.title}
                imageUrl={
                  blog.blogImage?.asset
                    ? urlFor(blog.blogImage.asset)
                        .fit('max')
                        .auto('format')
                        .url()
                    : undefined
                }
                slug={blog.slug?.current}
                date={new Date(blog._updatedAt)}
                category={blog.categories?.[0]._key!}
                excerpt={blog.excerpt!}
                className="w-full"
              />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </SanityWrapper>
  );
}
